import round from "lodash/round";
import user from "./user";

const mmInInch = 25.4;

function getLocale() {
  return user.currentUser?.Locale || navigator.language || "en-US";
}

export function getUnits() {
  const locale = getLocale();
  if (locale === "en-US") return "in";
  return "mm";
}

export function formatDistance(distanceMm) {
  if (!distanceMm) return distanceMm;

  const units = getUnits();
  if (units === "in") {
    // precision is important because of float imperfections
    return round(distanceMm / mmInInch, 1);
  } else {
    return distanceMm;
  }
}

export function fromLocalDistance(distanceLocal) {
  if (!distanceLocal) return distanceLocal;

  const units = getUnits();
  if (units === "in") {
    return round(distanceLocal * mmInInch);
  } else {
    return round(distanceLocal);
  }
}
